import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../common/breadcrumb/Breadcrumbs";
import {
  getCallbackList

} from "../../api/login/Login";
import { useParams } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { ToastContainer } from "react-toastify";
import { message, Pagination, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import Loadar from "../../common/loader/Loader";
import CustomInputField from "../../common/CustomInputField";
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { Modal } from "react-bootstrap";
import moment from "moment";
const breadCrumbsTitle = {
  id: "1",
  title_1: "Callback",
  title_2: "Callback ",
};

const statusMap = {
  1: { color: "btn btn-warning", text: "Pending"  },
  2: { color: "btn btn-success", text: "Success" },
  3: { color: "btn btn-danger", text: "Failed" },
};

const CallBackList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedData , setSelectedData] = useState({})
  const [openModel , setOpenModel] = useState(false)
  const [count, setCount] = useState(10);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [resetKey, setResetKey] = useState(false);
  const defaultInitialValues = {
    start_date: "",
    end_date: "",
    txn_id: "",
    status: "",
    vendor :'',
  };
  const resetValues = {
    start_date: "",
    end_date: "",
    txn_id: "",
    status: "",
       vendor :'',
  };
  const [initialValues, setInitialValues] = useState(defaultInitialValues);

  const handleReset = (resetForm) => {
    resetForm();
    setInitialValues(resetValues);
    setFormKey((prev) => prev + 1);
    setCurrentPage(1);
    setResetKey((pre) => !pre);
    // getDmtTxnData(0);
  };

  const handleSubmit = (values) => {
   
    setCurrentPage(1);
    setInitialValues(values);
    setResetKey((pre) => !pre);
    // Add your API call here
  };

  const onChangeVal = (page) => {
    setResetKey((pre) => !pre);
    setCurrentPage(page);
  };

  const getData = async () => {
    setLoading(true);
    try {
      const res = await getCallbackList({
        ...initialValues,
        page: currentPage,
        count,
      });
      if (res && res.data) {
        setData(res?.data);
        setTotalCount(res?.data?.total[0].count);
      } else {
        setData(null);
         setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching DMT transaction data:", error);
      setData(null);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };



  const handleCloseModel = ()=>{
    setOpenModel(false)
    setSelectedData({})
  }

   const handleopenModel = (value)=>{
    setOpenModel(true)
    setSelectedData(value)
  }

const handleCopy = (value) => {
  let textToCopy;

  try {
    textToCopy = typeof value === "string" ? value : JSON.stringify(value, null, 4); // pretty-print objects
  } catch (err) {
    message.error("Failed to convert data to string");
    return;
  }

  navigator.clipboard.writeText(textToCopy)
    .then(() => {
      message.success("Data copied successfully");
    })
    .catch((err) => {
      message.error("Failed to copy data");
      console.error("Clipboard copy failed:", err);
    });
};




  useEffect(() => {
    getData();
  }, [resetKey, currentPage]);

  return (
    <>
      {loading && <Loadar />}
      <ToastContainer />

      <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />

      {/* // Filter Option // */}
      <div className="row m-4">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-responsive active-projects style-1">
                <div className="tbl-caption tbl-caption-2">
                  <h4 className="heading mb-0">
                    <b>{breadCrumbsTitle.title_2} Search</b>
                  </h4>
                </div>
                <Formik
                  key={formKey}
                  initialValues={initialValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({
                    values,
                    handleChange,
                    setFieldValue,
                    errors,
                    touched,
                    resetForm,
                  }) => (
                    <Form className="tbl-captionn">
                      <div className="row">
                        <div className="col-xl-4 mb-3">
                          <Field
                            as={CustomInputField}
                            type="date"
                            name="start_date"
                            placeholder="Start Date"
                           
                          />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Field
                            as={CustomInputField}
                            type="date"
                            name="end_date"
                            placeholder="End Date"
                          
                          />
                        </div>

                        <div className="col-xl-4 mb-3">
                          <Field
                            as={CustomInputField}
                            type="text"
                            name="txn_id"
                            placeholder="Transaction ID"
                           
                          />
                        </div>
                      

                          <div className="col-xl-4 mb-3">
                          <Field
                            as={CustomInputField}
                            type="text"
                            name="vendor"
                            placeholder="Vendor Name"
                           
                          />
                        </div>

                        <div className="col-xl-4 mb-3">
                          <Field
                            as="select"
                            className="form-select"
                             name="status"
                            
                            placeholder="Select Status"
                          >
                            <option value="">Select Status</option>
                             {Object.entries(statusMap).map(([key, value]) => (
                              <option key={key} value={value.text}>
                                {value.text}
                              </option>
                            ))}
                          </Field>
                        </div>
                     
                        <div className="col-lg-12 col-md-12 mb-4">
                          <div className="d-flex justify-content-start">
                            <button
                              className="btn btn-primary me-2"
                              type="submit"
                            >
                              <i className="fas fa-search"></i> Search
                            </button>
                            <btn
                              className="btn btn-secondary"
                              type="button"
                              onClick={() => handleReset(resetForm)}
                            >
                              <i className="fas fa-refresh"></i> Reset
                            </btn>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* // filter option end here  */}

      {/* // table section  */}
      {data?.CallBackData?.length > 0 ? (
        <>
          <section className="ListDistributer exppdf">
            <div className="row m-4">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body p-0">
                    <div className="table-responsive active-projects style-1">
                      <div className="tbl-caption">
                        <h4 className="heading mb-0">
                          <b>{breadCrumbsTitle.title_2} List</b>
                        </h4>
                     
                      </div>
                   
                      <div
                        id="empoloyees-tblwrapper_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="table-to-xls"
                          className="table dataTable no-footer"
                          role="grid"
                          aria-describedby="empoloyees-tblwrapper_info"
                        >
                          <thead>
                            <tr role="row">
                              <th>Sr. No</th>
                              <th> Created Date / Time</th>
                              <th> Updated Date / Time</th>
                              <th>Vendor</th>
                              <th> API Id</th>
                              <th> Service </th>
                              <th> Transaction Id </th>
                              <th> Error </th>
                              <th>Retry Count</th>
                              <th>Status</th>
                              <th>Webhook</th>
                              <th> User Name</th>
                              <th> User Email</th>
                              <th> User Mobile </th>
                              <th>View Data</th>
                              <th>View Decrypted Data</th>
                              <th>View Webhook Data</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.CallBackData?.map((item, i) => (
                              <tr key={i} role="row" className="odd">
                                <td>{(i + 1)+ ((currentPage-1) * count )}</td>
                                <td>{moment(item?.createdAt).format('LLL')}</td>
                                <td>{moment(item?.updatedAt).format('LLL')}</td>
                                <td>{item?.vendor ?? '--'}</td>
                                <td>{item?.api_id ?? '--'}</td>
                                <td>{item?.service ?? '--'}</td>
                                <td>{item?.txn_id ?? '--'}</td>
                                <td>{item?.error ?? '--'}</td>
                                <td>{item?.retryCount ?? '--'}</td>
                                <td>{item?.status ?? '--'}</td>
                                <td>{item?.webhook ?? '--'}</td>
                                <td>{item?.user?.name ?? '--'}</td>
                                <td>{item?.user?.email ?? '--'}</td>
                                <td>{item?.user?.mobile ?? '--'}</td>
                                <td><Button variant="outline-primary" onClick={() => handleopenModel(item?.data ?? {})}
                              >
                            View  Data
                            </Button></td>
                            <td><Button variant="outline-primary" onClick={() => handleopenModel(item?.decryptData ?? {})}
                              >
                            View  Data
                            </Button></td>
                                

                                <td><Button variant="outline-primary" onClick={() => handleopenModel(item?.webhookData ?? {})}
                              >
                            View  Data
                            </Button></td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        className="dataTables_info"
                        id="empoloyees-tblwrapper_info"
                        role="status"
                        aria-live="polite"
                      >
                        Total {totalCount} entries
                      </div>
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="empoloyees-tblwrapper_paginate"
                      >
                        <Pagination
                          total={totalCount}
                          current={currentPage}
                          onChange={onChangeVal}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      ) : (
        <div className="text-center mt-4">
          <h3>No data available</h3>
        </div>
      )}
      {/* // table section  */}


      {openModel && 
      
      <>
       <Modal
                    show={openModel}
                    onHide={handleCloseModel}
                    centered
                    className=""
                  >
                    <Modal.Body
                      style={{ backgroundColor: "#fff" }}
                      className=""
                    >
                      <button
                        style={{ color: "#000000" }}
                        className="pkg-congrats-modal__close"
                        onClick={handleCloseModel}
                      >
                        ×
                      </button>
                    
        <div className="row">

      
                                      <div className="col-12">
      
                                         <Card style={{ width: '100%' , border:'none' , boxShadow:'none'}}>
      
    
      <ListGroup className="list-group-flush"  style={{maxHeight:'300px' ,height:'300px'}}>
      
      
      
      <pre style={{fontSize:'18px'}}>
          {JSON.stringify(selectedData ,  null, 4)}
      </pre>
      
      </ListGroup>
      <button className="btn btn-light" onClick={()=>handleCopy(selectedData)} > Copy Data</button>
      
      </Card>
      </div>
        </div>
          </Modal.Body>
                      </Modal>
      </>
      
      }
    </>
  );
};

export default CallBackList;
